import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import utils from 'helpers/utils';

class RenderSelectInputField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.startingValue,
        };
    }

    handleChange = (e, index, value) => {
        if (this.state.value === value) {
            return;
        }

        this.setState({
            value: value,
        });

        if (utils.isFunction(this.props.selectedValue)) {
            return this.props.selectedValue(value);
        }

        this.props.input.onChange(value);
    }

    render() {
        const {
            autoWidth,
            children,
            disabled,
            fullWidth,
            label,
            meta: {
                error,
                touched,
            },
            style,
        } = this.props;

        return (
            <SelectField
                autoWidth={ autoWidth }
                disabled={ disabled }
                errorText={ touched && error }
                floatingLabelText={ label }
                floatingLabelFixed={ true }
                fullWidth={ fullWidth }
                onChange={ this.handleChange }
                style={ style }
                value={ this.state.value }
            >
                { children }
            </SelectField>
        );
    }
}

RenderSelectInputField.defaultProps = {
    startingValue: '0',
};

RenderSelectInputField.propTypes = {
    autoWidth: PropTypes.bool,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string.isRequired,
    selectedValue: PropTypes.func,
    startingValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    style: PropTypes.object,
    meta: PropTypes.shape({
        error: PropTypes.string,
        touched: PropTypes.bool,
    }),
};

export default RenderSelectInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderSelectInputField.js